import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotMoviesSection from './components/HotMoviesSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import ArticleSection from './components/ArticleSection';

const seo = {
  title: '首页',
  description: '红桃影视是您的首选在线影视平台，提供海量高清电影、电视剧、综艺节目免费在线观看。红桃影视汇聚全球优质影视资源，支持多端流畅播放，每日更新最新影视内容。',
  keywords: '红桃影视,红桃影视在线观看,红桃影视高清资源,红桃影视最新电影,红桃影视免费观看',
  canonicalUrl: 'https://hongtaomovies.com',
};

export default function Home() {
  return (
    <>
      <SEOHead {...seo} />
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <HotMoviesSection />
        <LatestUpdatesSection />
        <ArticleSection />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="bg-primary-500 rounded-3xl p-10 md:p-14 text-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-background-50"></div>
                <div className="absolute -bottom-20 -left-20 w-60 h-60 rounded-full bg-background-50"></div>
              </div>
              <div className="relative z-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                  随时随地，畅享高清影视
                </h2>
                <p className="text-background-200/90 text-sm md:text-base mb-8 max-w-lg mx-auto">
                  下载红桃影视APP，海量高清资源触手可及
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="#"
                    className="px-8 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-apple-line mr-2"></i>
                    App Store
                  </a>
                  <a
                    href="#"
                    className="px-8 py-3 rounded-full bg-background-50/20 text-background-50 border border-background-300/30 font-medium text-sm hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-android-line mr-2"></i>
                    Android 下载
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}